const state = {
    isUseOilTemp: false,//是否使用加油草稿数据
    isUseETCTemp: false,//是否使用过路费草稿数据
}

const mutations = {
    UPDATE_OIL_TAG: (state, value) => {
        state.isUseOilTemp = value
    },
    UPDATE_ETC_TAG: (state, value) => {
        state.isUseETCTemp = value
    }
}

const actions = {
    // 是否选择用草稿数据
    updateOilTag({
        commit
    }, data) {
        commit('UPDATE_OIL_TAG', data)
    },
    // 是否选择用草稿数据
    updateETCTag({
        commit
    }, data) {
        commit('UPDATE_ETC_TAG', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/fee.js